module.exports = __webpack_public_path__ + "static/img/Lydia-Williams.ef4f0cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Lydia-Williams.jpg
// module id = +jpP
// module chunks = 0